// Asset URLs from design guidelines + user uploads
export const ASSETS = {
  logos: {
    rebel:
      "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/wocp8v2s_rebel_banner_4096x2304-Photoroom.png",
    trendia:
      "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/g5o9omtz_trendia_app_icon_512x512.png",
    topwallet: "/logos/topwallet.png",
  },
  hero_bg:
    "https://static.prod-images.emergentagent.com/jobs/def742c1-9e81-4a98-aa93-44bed548504c/images/12a02951427c58066cb8e04e60e8008a70514d368ef26bb0b9e32ef3b4163d45.png",
  // 3 originales para el hero
  trendia_screens: [
    "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/uj2yvdwo_ChatGPT%20Image%2023%20may%202026%2C%2023_22_36.png",
    "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/wwq6sgs0_ChatGPT%20Image%2023%20may%202026%2C%2023_17_55.png",
    "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/qluu8ub8_ChatGPT%20Image%2023%20may%202026%2C%2023_16_07.png",
  ],
  // Galería completa: 3 originales + 4 nuevas (sin duplicados)
  trendia_gallery: [
    "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/uj2yvdwo_ChatGPT%20Image%2023%20may%202026%2C%2023_22_36.png",
    "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/wwq6sgs0_ChatGPT%20Image%2023%20may%202026%2C%2023_17_55.png",
    "https://customer-assets.emergentagent.com/job_def742c1-9e81-4a98-aa93-44bed548504c/artifacts/qluu8ub8_ChatGPT%20Image%2023%20may%202026%2C%2023_16_07.png",
    "https://customer-assets.emergentagent.com/job_polyglot-trendia-web/artifacts/1qo8zr2o_ChatGPT%20Image%2024%20may%202026%2C%2000_35_40.png",
    "https://customer-assets.emergentagent.com/job_polyglot-trendia-web/artifacts/3edembs5_ChatGPT%20Image%2024%20may%202026%2C%2000_33_20.png",
    "https://customer-assets.emergentagent.com/job_polyglot-trendia-web/artifacts/gox3f3y0_ChatGPT%20Image%2024%20may%202026%2C%2000_31_32.png",
    "https://customer-assets.emergentagent.com/job_polyglot-trendia-web/artifacts/6thkznnh_ChatGPT%20Image%2024%20may%202026%2C%2000_28_31.png",
  ],
  topwallet_concepts: [
    "https://static.prod-images.emergentagent.com/jobs/def742c1-9e81-4a98-aa93-44bed548504c/images/d3ca409cbb8ffc3d775626ea14d896299317aa8c5dd7cf8b3c4fc22f63583028.png",
    "https://static.prod-images.emergentagent.com/jobs/def742c1-9e81-4a98-aa93-44bed548504c/images/0ac8c64a48468fb200aa96c293510781f7399cd34521eb07612e968eb0476da0.png",
    "https://static.prod-images.emergentagent.com/jobs/def742c1-9e81-4a98-aa93-44bed548504c/images/53248d91c3f85f41fec5237604bae7a92a92b92533c277de9e81a786e088f083.png",
    "https://static.prod-images.emergentagent.com/jobs/def742c1-9e81-4a98-aa93-44bed548504c/images/27755768a2546a3061c363384d92d6f114168ce3cb07c177431e3383ef42eb5d.png",
  ],
};

// Placeholder URLs (replace with real ones later)
export const LINKS = {
  trendia_play: "#", // App link pendiente — actualizar cuando esté publicada en Google Play
  trendia_web: "https://www.trendia.cloud",
  topwallet_web: "https://www.topwallet.cloud",
  academy: "/academy", // Academia RE₿EL Online — ruta interna
};
